"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighlightedText = void 0;
var react_1 = __importDefault(require("react"));
var search_matcher_1 = require("./utils/search-matcher");
/**
 * Renders `value` with each occurrence of a matcher term wrapped in a
 * span. The matcher is expected to be the one returned by
 * `buildSearchMatcher` so the alternation ordering matches the captured
 * groups produced by `String.prototype.split`.
 */
exports.HighlightedText = function (_a) {
    var value = _a.value, matcher = _a.matcher, _b = _a.highlightClassName, highlightClassName = _b === void 0 ? 'ws-search-highlight' : _b;
    if (!matcher) {
        return react_1.default.createElement(react_1.default.Fragment, null, value);
    }
    var parts = value.split(matcher);
    var lowerTerms = search_matcher_1.getMatcherTerms(matcher);
    return (react_1.default.createElement(react_1.default.Fragment, null, parts.map(function (part, index) {
        if (lowerTerms.indexOf(part.toLowerCase()) >= 0) {
            return (react_1.default.createElement("span", { key: "hl-" + index, className: highlightClassName }, part));
        }
        return react_1.default.createElement(react_1.default.Fragment, { key: "tx-" + index }, part);
    })));
};
